<template>
    <div id="map"></div>
</template>

<script>
    import 'leaflet/dist/leaflet.css';
	import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package
	import * as L from 'leaflet';
    import 'leaflet-defaulticon-compatibility';
    import axios from 'axios';
    export default {
        name: "mymap",
        data () { 
            return {          
                map: null,
                tileLayer: null,
                addMarker: null,
                searchBuffer: null,
                selParcels: null,
                infoControl: null,
                circle: null,
                parStyle: {"color": "red", "weight": 2.5}
            }
        },
        mounted(){
            let _this = this
            //Create and load Leaflet Map
            _this.map = new L.map('map').setView([35.260, -80.807], 10);
            L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
                attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
            }).addTo(_this.map);
           /*L.tileLayer('https://maps.heigit.org/openmapsurfer/tiles/roads/webmercator/{z}/{x}/{y}.png', {
	            attribution: 'Imagery from <a href="http://giscience.uni-hd.de/">GIScience Research Group @ University of Heidelberg</a> | Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(_this.map);*/
            L.tileLayer.wms("http://maps.co.mecklenburg.nc.us/geoserver/wms",{
                layers: "postgis:day_cares",
                format: 'image/png',
                transparent: true
            }).addTo(_this.map);
            L.tileLayer.wms("http://maps.co.mecklenburg.nc.us/geoserver/wms",{
                layers: "postgis:public_schools",
                format: 'image/png',
                transparent: true
            }).addTo(_this.map);
            L.tileLayer.wms("http://maps.co.mecklenburg.nc.us/geoserver/wms",{
                layers: "postgis:schools_private",
                format: 'image/png',
                transparent: true
            }).addTo(_this.map);
            L.tileLayer.wms("http://maps.co.mecklenburg.nc.us/geoserver/wms",{
                layers: "postgis:charter_schools",
                format: 'image/png',
                transparent: true
            }).addTo(_this.map);
            _this.searchBuffer = L.geoJson().addTo(_this.map);
            _this.selParcels = L.geoJson().addTo(_this.map);
            _this.infoControl = L.control({position: 'topright'});
            var apMap = _this.map
            _this.infoControl.onAdd = function (apMap) {
                _this._div = L.DomUtil.create('div', 'info-content');
                return _this._div;
            };
            _this.infoControl.addTo(_this.map);
        },
        methods: {
            mapAddress(){
                if(this.addMarker){
                    var marker = this.addMarker;
                    var refMap = this.map;
                    refMap.removeLayer(marker);
                }
                if(this.circle){
                    this.map.removeLayer(this.circle);
                }
                this.selParcels.clearLayers();
                this.searchBuffer.clearLayers();
               
                /*var latLng = this.$store.state.latlng;
                var lat = latLng[0];
                var lng = latLng[1];*/
                var matID = this.$store.state.matID;
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/query/master_address_table?columns=cde_use&filter=objectid=" + matID}).then(result =>{
                    if (result.data[0].cde_use == '01'){
                        this.bufferParcel();
                    } else{
                        this.bufferPoint();
                    }
                })
                var addrLatLng = L.latLng(this.$store.state.latlng);
                //console.log(addrLatLng);
                this.addMarker = L.marker(addrLatLng).addTo(this.map);
                this.map.setView([addrLatLng.lat, addrLatLng.lng], 15);

            },
            bufferParcel(){
                console.log("pacel buffer")
                let info = document.querySelector ( '.info-content' );
                info.innerHTML= "<p style='text-align:center;font-size:14px;'><b>FACILITIES WITHIN 1000 FEET</b></p>";

                //this.infoControl.innerHTML= "<p style='text-align:center;font-size:14px;'><b>FACILITIES WITHIN 1000 FEET</b></p>";
                var pid = this.$store.state.selPID;
                //Search for Daycares
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_feature/tax_parcels/daycare_parcels?geom_column_from=the_geom&geom_column_to=the_geom&columns=daycare_parcels.facility_n%20as%20name%2Cdaycare_parcels.address%2CST_AsGeoJSON(st_transform(daycare_parcels.the_geom%2C4326))%20as%20parbnd&filter=tax_parcels.pid%3D'" + pid + "'&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>DAYCARE(S)</u></b></p>";
                        var len = result.data.length
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd))
                            this.selParcels.setStyle(this.parStyle)
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search for Public Schools
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_feature/tax_parcels/public_school_parcels?geom_column_from=the_geom&geom_column_to=the_geom&columns=public_school_parcels.schl,public_school_parcels.name,ST_AsGeoJSON(st_transform(public_school_parcels.the_geom,4326)) as parbnd&filter=tax_parcels.pid='" + pid + "'&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>PUBLIC SCHOOL(S)</u></b></p>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search for Private Schools
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_feature/tax_parcels/private_school_parcels?geom_column_from=the_geom&geom_column_to=the_geom&columns=private_school_parcels.school as name,ST_AsGeoJSON(st_transform(private_school_parcels.the_geom,4326)) as parbnd&filter=tax_parcels.pid='" + pid + "'&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>PRIVATE SCHOOL(S)</u></b></p>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search for Charter Schools
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_feature/tax_parcels/charter_school_parcels?geom_column_from=the_geom&geom_column_to=the_geom&columns=charter_school_parcels.name,ST_AsGeoJSON(st_transform(charter_school_parcels.the_geom,4326)) as parbnd&filter=tax_parcels.pid='" + pid + "'&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>CHARTER SCHOOL(S)</u></b></p>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search for School Construction Sites
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_feature/tax_parcels/view_school_permit?geom_column_from=the_geom&geom_column_to=the_geom&columns=view_school_permit.project_name,ST_AsGeoJSON(st_transform(view_school_permit.the_geom,4326)) as parbnd&filter=tax_parcels.pid='" + pid + "'&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><div style='text-align:center;'><b><u>SCHOOL CONSTRUCTION SITE(S)</u></b></div>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            info.innerHTML = info.innerHTML +  "<div style='text-align:center;'>" + result.data[i].project_name.toUpperCase() + "</dv>";  
                        }    
                    }
                })
                //Draw parcel Buffer
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_feature/tax_parcels/master_address_table?geom_column_from=the_geom&geom_column_to=the_geom&columns=ST_AsGeoJSON(st_transform(st_Buffer(tax_parcels.the_geom, 1000), 4326)) as parbuff&filter=tax_parcels.pid='" + pid + "'&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        var parbuff = result.data[0].parbuff;
                        this.searchBuffer.addData(JSON.parse(parbuff));    
                    }
                })
            },
            bufferPoint(){
                console.log("point buffer")
                if(this.addMarker){
                    var marker = this.addMarker;
                    var refMap = this.map;
                    refMap.removeLayer(marker);
                }
                if(this.circle){
                    this.map.removeLayer(this.circle);
                }
                this.selParcels.clearLayers();
	            this.searchBuffer.clearLayers();
                var latLng = this.$store.state.latlng;
                console.log(latLng)
                var addrLatLng = L.latLng(this.$store.state.latlng);
                this.addMarker = L.marker(addrLatLng).addTo(this.map);
                var lat = latLng[0];
                var lng = latLng[1];
                console.log(lat + ", " + lng)
                //var info = document.getElementsByClassName("info-content");
                let info = document.querySelector ( '.info-content' )
                info.innerHTML= "<p style='text-align:center;font-size:14px;'><b>FACILITIES WITHIN 1000 FEET</b></p>";
                //Search for Daycares
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_point/daycare_parcels/" + lng + "," + lat + ",4326?geom_column=the_geom&columns=facility_n%20as%20name%2C%20address%2C%20ST_AsGeoJSON(st_transform(the_geom,4326)) as parbnd&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>DAYCARE(S)</u></b></p>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            console.log(result.data[i].name)
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }   
                    }
                })
                //Search for Public Schools
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_point/public_school_parcels/" + lng + "," + lat + ",4326?geom_column=the_geom&columns=name%2C%20ST_AsGeoJSON(st_transform(the_geom,4326)) as parbnd&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        var len = result.data.length;
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>PUBLIC SCHOOLS(S)</u></b></p>";
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search for Private Schools
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_point/private_school_parcels/" + lng + "," + lat + ",4326?geom_column=the_geom&columns=school as name%2C%20ST_AsGeoJSON(st_transform(the_geom,4326)) as parbnd&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>PRIVATE SCHOOL(S)</u></b></p>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search for Charter Schools
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_point/charter_school_parcels/" + lng + "," + lat + ",4326?geom_column=the_geom&columns=name%2C%20ST_AsGeoJSON(st_transform(the_geom,4326)) as parbnd&distance=1000"}).then(result =>{
                    if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><p style='text-align:center;'><b><u>CHARTER SCHOOL(S)</u></b></p>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){
                            //Add Daycare Name to info name =  result.data[i].name
                            var parbnd = result.data[i].parbnd;
                            this.selParcels.addData(JSON.parse(parbnd));
                            this.selParcels.setStyle(this.parStyle);
                            info.innerHTML = info.innerHTML +  "<div style='margin-left:20px;'>" + result.data[i].name + "</div>";
                        }    
                    }
                })
                //Search School Construction Sites
                axios({method:"GET", "url": "http://maps.co.mecklenburg.nc.us/api2/v1/intersect_point/view_school_permit/" + lng + "," + lat + ",4326?geom_column=the_geom&columns=project_name%2C%20ST_AsGeoJSON(st_transform(the_geom,4326)) as parbnd&distance=1000"}).then(result =>{
                if (result.data.length > 0){
                        info.innerHTML = info.innerHTML + "<hr class='hr-style'><div style='text-align:center;'><b><u>SCHOOL CONSTRUCTION SITE(S)</u></b></div>";
                        var len = result.data.length;
                        for (var i = 0; i < len; i++){                            
                            info.innerHTML = info.innerHTML +  "<div style='text-align:center;'>" + result.data[i].project_name.toUpperCase() + "</div>";  
                        }    
                    }
                })
                //Draw Address Point Buffer
                //Circle Radius is in meters 1000 ft. = 304.8 m
                this.circle = L.circle([parseFloat(lat), parseFloat(lng)], 304.8, {
                    color: '#3399FF',
                    weight: 2.5,
                    fillColor: '#EFEFEF',
                    fillOpacity: 0.5,
                    clickable: false
                });
                this.map.addLayer(this.circle);
                this.map.setView([parseFloat(lat), parseFloat(lng)], 16);
            }
        },
        computed: {
            latlng(){
                return this.$store.state.latlng
            }
        },
        watch: {
            latlng: function(){
                this.mapAddress();
            }
        }
    }
</script>

<style scoped>
    #map{
        width:100%;
	    height:525px;
    }   
</style>